import React from "react";
import LoadingSplashIcon from "../Icons/LoadingSplashIcon";

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <LoadingSplashIcon width="20%" height="20%" />
    </div>
  );
}

export default LoadingScreen;
